export default "__VITE_ASSET__3411e2c6__"